<div class="modal">
  <div class="card card--xl">
    <div class="card-header d-flex justify-content-between">
      <h3 class="card-title">Radni nalozi za isporuku za {{ deliveryDeadline | date: 'dd.MM.yyyy.'}}</h3>
    </div>

    <div class="card-body card-body-scrollable">
      <table class="table table-hover table-vcenter card-table">
        <thead>
          <tr>
            <th class="width-5"></th>
            <th class="width-40">Radni nalog</th>
            <th class="width-25">Rokovi</th>
            <th class="width-30">Status</th>
          </tr>
        </thead>
        <tbody>
          <tr class="pointer" *ngFor="let order of workOrders; let i = index" (click)="onSelectWorkOrder(order)">
            <td>
              <i class="fa fa-check-circle" [class.text-green]="selectedWorkOrder?.workOrderId === order?.workOrderId"></i>
            </td>
            <td>
              <div>{{ order.client }}</div>
              <div>{{ order.name }}</div>
              <div class="font-weight-bold">{{ order.upisId }}</div>
              <div>{{ order.totalQuantityPlanned | digitFormat }} {{ order.unit }}</div>
            </td>
            <td>
              <div
                class="d-flex align-items-center table-date-container"
                tooltipStr="Datum prijema zahteva"
                *ngIf="order.receiptOfRequestDate">
                <div class="table-date-container__text">
                  {{ order.receiptOfRequestDate | date : 'dd/MM/yyyy' }}
                </div>
                <div class="table-date-container__icon">
                  <i class="fa fa-folder-open ml-2"></i>
                </div>
              </div>
              <div
                class="d-flex align-items-center mb-1 table-date-container"
                tooltipStr="Rok za izradu dokumentacije - modelarnica"
                *ngIf="order.engineerDocumentationDeadline && order?.jobType?.length >= 2">
                <div class="table-date-container__icon">
                  <i
                    [class.text-green]="order.engineerDocumentationCompletionDate && order.engineerMaterialsCompletionDate"
                    class="fa fa-drafting-compass"></i>
                </div>
                <div class="table-date-container__text">
                  {{ order.engineerDocumentationDeadline | date : 'dd/MM/yyyy' }}
                </div>
                <div class="table-date-container__icon">
                  <i class="fa fa-file-alt ml-2"></i>
                </div>
              </div>
              <div
                class="d-flex align-items-center mb-1 table-date-container"
                tooltipStr="Rok za izradu dokumentacije"
                *ngIf="order.documentationDeadline">
                <div class="table-date-container__icon">
                  <i
                    *ngIf="order?.jobType?.length > 0"
                    [class.text-green]="isEngineerOrGraphicConfirmed(order)"
                    class="fa {{ iconToShow(order) }}"></i>
                </div>
                <div class="table-date-container__text">
                  {{ order.documentationDeadline | date : 'dd/MM/yyyy' }}
                </div>
                <div class="table-date-container__icon">
                  <i class="fa fa-file-alt ml-2"></i>
                </div>
              </div>
              <div class="d-flex align-items-center table-date-container" tooltipStr="Rok za isporuku" *ngIf="order.deliveryDeadline">
                <div class="table-date-container__text">
                  {{ order.deliveryDeadline | date : 'dd/MM/yyyy' }}
                </div>
                <div class="table-date-container__icon">
                  <i class="fa fa-truck ml-2"></i>
                </div>
              </div>
              <div
                class="d-flex align-items-center table-date-container"
                tooltipStr="Rok za sukcesivnu isporuku"
                *ngIf="link === 'for-delivery' && order.partialDeliveryDate">
                <div class="table-date-container__text">
                  {{ order.partialDeliveryDate | date : 'dd/MM/yyyy' }}
                </div>
                <div class="table-date-container__icon">
                  <i class="fa fa-truck-loading ml-2"></i>
                </div>
              </div>
            </td>
            <td>{{ order.status || '/' }}</td>
          </tr>
        </tbody>
      </table>
      <app-empty *ngIf="isListEmpty"></app-empty>
    </div>

    <div class="card-footer bg-white text-right">
      <button class="btn btn-secondary btn-question mr-2" (click)="emitFalse()">Odustani</button>
      <button class="btn btn-success btn-question" (click)="onSave()" [disabled]="!selectedWorkOrder">Dodaj</button>
    </div>
  </div>
</div>
